const createTomaUsadosGuard = store => {
  let generation = 0
  return async (_to, _from, next) => {
    const request = ++generation
    if (!store.state.token) {
      try { await store.dispatch('loadLocalStorage') }
      catch (_) {
        if (request !== generation) return next(false)
        store.commit('tomaUsados/clearAccess')
        return next({ path: '/login' })
      }
    }
    if (request !== generation) return next(false)
    if (!store.state.token) {
      store.commit('tomaUsados/clearAccess')
      return next({ path: '/login' })
    }
    try {
      await store.dispatch('tomaUsados/loadAccess')
      if (request !== generation) return next(false)
      next()
    } catch (error) {
      if (request !== generation || error.code === 'STALE_REQUEST') return next(false)
      store.commit('tomaUsados/clearAccess')
      next({ path: '/' })
      try { await store.dispatch('show_snackbar', { text: 'No se pudo verificar el acceso a Toma de usados. Consultá a Sistemas.', color: 'error' }) } catch (_) { /* Navigation stays denied even if feedback fails. */ }
    }
  }
}
export default createTomaUsadosGuard
